<template>
  <div style="margin: 0.1rem 0.11rem 0" class="useinfo">
    <ul class="infoHead">
      <li style="height: 0.9rem">
        <b>头像</b>
        <div class="infolistRight">
          <!--<img style="width: 0.64rem;height: 0.64rem;" src="../../assets/images/wx.png">-->
          <vue-crop-avatar
            v-if="personInfo.head"
            :isRound="false"
            :maxCropWidth="1000"
            :maxCropHeight="1000"
            :cropBoxBorderColor="`#666`"
            :defaultImgPath="personInfo.head"
            @getrawdata="getCanvasData"
            outputType="image/png"
          ></vue-crop-avatar>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
        <div v-if="personInfo !== ''" class="dataComp">
          <p>{{ personInfo.completionRate }}</p>
          <b>资料完成度</b>
        </div>
      </li>
      <li @click="updata('nickname')">
        <b>昵称</b>
        <div class="infolistRight">
          <p v-if="personInfo !== ''">{{ personInfo.smallname }}</p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
    </ul>
    <ul class="infoHead">
      <li @click="updata('name')">
        <b>姓名</b>
        <div class="infolistRight">
          <p v-if="personInfo !== ''">{{ personInfo.realname }}</p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
      <li v-if="personInfo != ''" @click="ifDate">
        <b>生日</b>
        <div class="infolistRight">
          <p v-if="personInfo !== ''">{{ personInfo.birthdate }}</p>
          <img v-if="!isbirthdate" class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
      <li @click="regionClick">
        <b>所在地：</b>
        <div class="infolistRight">
          <p>{{ personInfo.area ? personInfo.area : '请选择所在地' }}</p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
      <li @click="ifGender">
        <b>性别</b>
        <div class="infolistRight">
          <p v-if="personInfo.sex == '男' || personInfo.sex == '女'">{{ personInfo.sex }}</p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
    </ul>
    <!--    皮肤测试入口屏蔽-->
    <!--    <ul class="infoHead" v-if="loaded">-->
    <!--      <li @click="handleSkinResult">-->
    <!--        <b>皮肤测试</b>-->
    <!--        <div class="infolistRight" >-->
    <!--          <img class="jt" src="../../assets/images/jt2.png">-->
    <!--        </div>-->
    <!--      </li>-->
    <!--      <li style="letter-spacing: 0.01rem;">-->
    <!--        {{skinInfo.orderid ? ('肌肤分析结果：'+skinInfo.skin_type) : '根据皮肤测试结果给出更专业的皮肤护理及产品搭配方案'}}-->
    <!--      </li>-->
    <!--    </ul>-->
    <button class="saveBtn" @click="submit">保存</button>
    <awesome-picker
      ref="pickerGender"
      :textTitle="pickerGender.textTitle"
      :data="pickerGender.data"
      :anchor="pickerGender.anchor"
      @confirm="handlePickerConfirmGender"
    ></awesome-picker>
    <awesome-picker
      ref="pickerDate"
      :textTitle="pickerDate.textTitle"
      :type="pickerDate.type"
      :anchor="pickerDate.anchor"
      @confirm="handlePickerConfirmDate"
    ></awesome-picker>
    <awesome-picker
      ref="pickerRegion"
      :textTitle="pickerRegion.textTitle"
      :data="pickerRegion.data"
      :anchor="pickerRegion.anchor"
      @confirm="handlePickerConfirmRegion"
    ></awesome-picker>
    <!--<div>-->
    <!--<head-cut></head-cut>-->
    <!--</div>-->
  </div>
</template>

<script>
import {
  getCookie,
  isWeixin,
  fenxiang,
  formateName,
  basepath,
  cosaccesspath
} from '../../assets/common/js/config'
import VueCropAvatar from 'vue-crop-avatar'
const sex = ['男', '女']

export default {
  name: 'personalInfo',
  components: {
    VueCropAvatar
  },
  data() {
    return {
      userAvatar: undefined,
      progress: '0%',
      isbirthdate: 0,
      personInfo: {
        head: '',
        completionRate: '',
        smallname: '',
        realname: '',
        birthdate: '',
        sex: '',
        area: '',
        areaid: ''
      },
      pickerRegion: {
        anchor: [],
        textTitle: '区域选择',
        data: []
      },
      pickerGender: {
        anchor: [],
        textTitle: '性别选择',
        data: [sex]
      },
      pickerDate: {
        anchor: [],
        textTitle: '日期选择',
        type: 'date'
      },
      skinInfo: JSON.parse(getCookie('ndoresult')) || {},
      loaded: false
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'personalinfo' })
    }
    this.getData()
    // 皮肤测试
    // let url = this.$ajax.getNdoResult_URL
    // this.$customRequestAjax(url).then(res => {
    //   if (res.data.code === 200) {
    //     this.skinInfo = res.data
    //     this.loaded = true
    //   }
    // })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadHead(file) {
      console.log(file)
      var that = this
      that.$toast.loading({
        duration: 0,
        message: '正在上传，请稍后...',
        forbidClick: true
      })
      that.$cos.uploadFile({
        key: '/personalinfo_h5' + file.name + '.jpg',
        file: file,
        success: function (data) {
          that.personInfo.head = cosaccesspath + data
          var obj = JSON.parse(sessionStorage.getItem('personal_information'))
          obj.head = that.personInfo.head
          sessionStorage.setItem('personal_information', JSON.stringify(obj))
          that.$toast({
            message: '上传成功',
            icon: require('../../assets/images/succ.png')
          })
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadHead: async function (imgFile) {
      // let OSS = require('ali-oss');
      const url = this.$ajax.getOssWeb_URL
      var that = this
      that.$toast.loading({
        duration: 0,
        message: '正在上传，请稍后...',
        forbidClick: true
      })
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + imgFile.name + '.' + 'png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', imgFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status === 200 && res.statusText == 'OK') {
              that.personInfo.head = that.ossImgUrl + `${dir}${str}`
              var obj = JSON.parse(sessionStorage.getItem('personal_information'))
              obj.head = that.personInfo.head
              sessionStorage.setItem('personal_information', JSON.stringify(obj))
              that.$toast({
                message: '上传成功',
                icon: require('../../assets/images/succ.png')
              })
            }
          })
        }
      })
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    ifGender: function () {
      this.$nextTick(() => {
        this.$refs.pickerGender.show()
      })
    },
    ifDate: function () {
      if (!this.isbirthdate) {
        this.$nextTick(() => {
          this.$refs.pickerDate.show()
        })
      }
    },
    getData: function () {
      this.$customRequestAjax(this.$ajax.getMeInfo_Member_URL).then((res) => {
        if (res.data.code == 200) {
          if (sessionStorage.getItem('personal_information')) {
            this.personInfo = JSON.parse(sessionStorage.getItem('personal_information'))
          }
          if (!this.personInfo.head) {
            this.personInfo = Object.assign(this.personInfo, res.data)
          } else {
            this.personInfo = Object.assign(res.data, this.personInfo)
          }
          sessionStorage.setItem('personal_information', JSON.stringify(this.personInfo))
          this.personInfo.head =
            this.personInfo.head || require('../../assets/images/errorheadimg.png')
          if (this.personInfo.birthdate) {
            this.isbirthdate = 1
          } else {
            this.isbirthdate = 0
          }
          this.getArea()
          this.$app.argFunc(
            () => {
              fenxiang({
                title: encodeURIComponent(res.data.sharetitle),
                desc: encodeURIComponent(res.data.sharedesc),
                imgx: res.data.shareimg,
                type: 'personalInfo',
                dataStr: 'type=personalInfo',
                path: 'personalInfo'
              })
            },
            () => {
              this.$app.shareFriends({
                title: encodeURIComponent(res.data.sharetitle),
                img: res.data.shareimg,
                link: basepath + 'perinfo'
              })
            }
          )
        }
      })
    },
    getArea: function () {
      var url = this.$ajax.getArea_URL
      // this.addressValue = JSON.parse(localStorage.getItem('edit_address'))
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.pickerRegion.data = res.data.data
          that.pickerRegion.data.forEach((item) => {
            item['value'] = item.name
            delete item['name']
            item['children'] = item.child
            delete item['child']
            item.children.forEach((itemSon) => {
              itemSon['province'] = item.value
              itemSon['value'] = itemSon.name
              delete itemSon['name']
              itemSon['children'] = itemSon.child
              delete itemSon['child']
              itemSon.children.forEach((itemGrandson) => {
                itemGrandson['value'] = itemGrandson.name
                delete itemGrandson['name']
                itemGrandson['city'] = itemSon.value
              })
            })
          })
          that.pickerRegion.data = res.data.data
        }
      })
    },
    regionClick: function () {
      if (this.pickerRegion.data.length > 0) {
        this.$refs.pickerRegion.show()
      } else {
        this.$toast('当前网络环境较差，请稍后再试')
      }
    },
    handlePickerConfirmRegion: function (v) {
      this.pickerRegion.anchor = v
      var that = this
      that.personInfo.area = ''
      that.personInfo.areaid = ''
      v.forEach(function (item, idx) {
        that.personInfo.area =
          that.personInfo.area === '' ? item.value : that.personInfo.area + '\t' + item.value
        switch (idx) {
          case 0:
            that.personInfo.areaid = that.pickerRegion.data[item.index].id
            break
          case 1:
            that.personInfo.areaid =
              that.personInfo.areaid +
              ',' +
              that.pickerRegion.data[v[idx - 1].index].children[item.index].id
            break
          case 2:
            that.personInfo.areaid =
              that.personInfo.areaid +
              ',' +
              that.pickerRegion.data[v[idx - 2].index].children[v[idx - 1].index].children[
                item.index
              ].id
            break
        }
      })
      sessionStorage.setItem('personal_information', JSON.stringify(this.personInfo))
    },
    handlePickerConfirmGender: function (v) {
      this.pickerGender.anchor = v
      this.personInfo.sex = v[0].value
      sessionStorage.setItem('personal_information', JSON.stringify(this.personInfo))
    },
    handlePickerConfirmDate: function (v) {
      this.pickerDate.anchor = v
      var that = this
      that.personInfo.birthdate = ''
      v.forEach(function (item) {
        if (item.value.length >= 3) {
          that.personInfo.birthdate += '/' + item.value.slice(0, item.value.length - 1)
        } else {
          that.personInfo.birthdate += '/0' + item.value.slice(0, item.value.length - 1)
        }
      })
      that.personInfo.birthdate = that.personInfo.birthdate.slice(
        1,
        that.personInfo.birthdate.length
      )
      sessionStorage.setItem('personal_information', JSON.stringify(this.personInfo))
    },
    getCanvasData: function (canvas) {
      var imgSrc = canvas.toDataURL('image/png')
      var imgName = 'headimg'
      var blob = this.dataURLtoBlob(imgSrc)
      var file = this.blobToFile(blob, imgName)
      this[this.$cos.isCosSwitch == 1 ? 'cosUploadHead' : 'uploadHead'](file)
      console.log(file)
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    updata: function (type) {
      switch (type) {
        case 'nickname':
          this.$app.argLink({
            path: '/update',
            query: {
              type: 'nickname'
            }
          })
          break
        case 'name':
          this.$app.argLink({
            path: '/update',
            query: {
              type: 'name'
            }
          })
          break
      }
    },
    submit: function () {
      this.$ckeckgraphic({
        content: this.personInfo.smallname + ',' + this.personInfo.realname,
        images: this.personInfo.head.replace(basepath, ''),
        callback: () => {
          var url = this.$ajax.updateMeInfo_URL
          var data = {
            head: this.personInfo.head.replace(cosaccesspath, ''),
            smallname: this.personInfo.smallname,
            realname: this.personInfo.realname,
            birthdate: this.personInfo.birthdate.replace(/\//g, '-'),
            sex: this.personInfo.sex,
            areaname: this.personInfo.area,
            areaid: this.personInfo.areaid
          }
          var that = this
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.loginFlowrate()
              that.$toast('修改成功')
              setTimeout(function () {
                that.$app.goUser()
              }, 500)
            }
          })
        }
      })
    },
    // 登录-转换变量-值修改时
    loginFlowrate() {
      let smallname, sex, birthdate
      smallname = formateName(this.personInfo.smallname)
      sex = this.personInfo.sex
      birthdate = this.personInfo.birthdate
      gio('people.set', 'userName_ppl', smallname)
      gio('people.set', 'gender_ppl', sex)
      gio('people.set', 'age_ppl', birthdate)
    },
    handleSkinResult: function () {
      if (this.skinInfo.orderid) {
        this.$app.argLink({
          path: '/analysisDetail',
          query: {
            orderid: this.skinInfo.orderid,
            source: 'records',
            sex: this.skinInfo.sex
          }
        })
      } else {
        this.$app.argLink({
          path: '/skinAnalysis'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.infoHead {
  border-radius: 0.04rem;
  margin-bottom: 0.11rem;
  background: #fff;
  &:last-of-type {
    padding-bottom: 0.13rem;
    & li {
      border-bottom: none;
    }
  }
  li {
    color: #b0b0b0;
    font-size: 0.13rem;
    border-bottom: 1px solid #efefef;
    min-height: 0.45rem;
    margin: 0 0.15rem;
    position: relative;
    .dataComp {
      position: absolute;
      right: -0.26rem;
      top: 0;
      text-align: center;
      background: linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      background: -webkit-linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      background: -moz-linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      background: -o-linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      background: -ms-linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      border-radius: 1rem 0 0 1rem;
      padding: 0.01rem 0.06rem 0.03rem 0.12rem;
      p {
        font-size: 0.13rem;
        color: #895808;
        font-weight: 600;
        margin-bottom: -0.04rem;
      }
      b {
        font-size: 0.08rem;
        color: #a36e18;
      }
    }
  }
  & li,
  & .infolistRight {
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
  }
  b {
    font-size: 0.15rem;
    color: #444444;
    display: block;
    font-weight: 600;
  }
  img {
    display: block;
  }
  .infolistRight {
    p {
      font-size: 0.13rem;
      color: #999999;
      max-width: 2.3rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .jt {
      width: 0.06rem;
      height: 0.11rem;
      margin-left: 0.07rem;
    }
  }
}
.saveBtn {
  width: 100%;
  height: 0.43rem;
  background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  border-radius: 25px;
  display: block;
  border: none;
  margin-top: 0.3rem;
  margin-bottom: 0.1rem;
  font-size: 17px;
  font-weight: 400;
  color: rgba(254, 254, 254, 1);
  outline: none;
}
</style>
<style>
.useinfo .avatar-box {
  width: 0.64rem !important;
  height: 0.64rem !important;
  border-radius: 50% !important;
  overflow: hidden !important;
}
.useinfo .modal .btn {
  background: none !important;
  border: none !important;
  outline: none !important;
  font-size: 0.16rem !important;
  font-family: 'PingFangSC' !important;
  font-weight: 400 !important;
  color: #fff !important;
  line-height: 0.22rem !important;
  position: absolute !important;
  right: 0.2rem !important;
  bottom: 0.2rem !important;
}
.useinfo .close {
  position: absolute !important;
  top: auto !important;
  right: auto !important;
  bottom: 0.2rem !important;
  left: 0.2rem !important;
  font-size: 0.16rem !important;
  color: rgba(0, 0, 0, 0) !important;
}
.useinfo .close:before {
  content: '取消';
  color: #fff !important;
  font-size: 0.16rem !important;
}
.useinfo .modal {
  background: #fff !important;
}
.useinfo .modal:before {
  content: '' !important;
  display: block !important;
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: #000 !important;
  opacity: 0.69 !important;
}
.useinfo .cropper-bg {
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/personalInfo.vue